<template>
  <aside class="footer-nav flex container-xs bg-white clearfix lg:hidden" style="display: none">
    <slot />
  </aside>
</template>

<script>
import VisSenseFactory from 'vissense'

export default {
  props: {
    bookingWidget: {
      type: String,
      required: true
    },
    container: {
      type: String,
      required: true
    }
  },
  computed: {
    isTabletOrMobile () {
      return window.matchMedia('only screen and (max-width: 1200px)').matches
    }
  },
  mounted () {
    const VisSense = VisSenseFactory(window)
    const bookingWidget = document.querySelector(this.bookingWidget)
    const bookingWidgetVisibility = VisSense(bookingWidget, { fullyvisible: 0.2 })

    const bookingWidgetMonitor = bookingWidgetVisibility.monitor({
      fullyvisible: () => { 
        if (this.isTabletOrMobile) {
          pushUpTrengoChat(false)
          $(this.$el).fadeOut()
        }
      },
      hidden: () => {
        if (this.isTabletOrMobile) {
          pushUpTrengoChat(true)
          $(this.$el).fadeIn()
        }
      }
    }).start()

    bookingWidgetMonitor.update()

    const container = document.querySelector(this.container)
    const containerVisibility = VisSense(container, { fullyvisible: 1 })

    const containerMonitor = containerVisibility.monitor({
      visible: () => {
        if (this.isTabletOrMobile) {
          pushUpTrengoChat(true)
          $(this.$el).fadeIn()
        }
      },
      hidden: () => {
        if (this.isTabletOrMobile) {
          pushUpTrengoChat(false)
          $(this.$el).fadeOut()
        }
      }
    }).start()

    containerMonitor.update()
  },
  methods: {
    show () {
      pushUpTrengoChat(true)
      $(this.$el).fadeIn()
    },
    hide () {
      pushUpTrengoChat(false)
      $(this.$el).fadeOut()
    }
  }
}
</script>

<style scoped>
.footer-nav {
  height: 80px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  border-top: 1px solid var(--border-primary);
}

.footer-nav.is-hidden {
  display: none;
}
</style>
